import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Typography, Box } from '@mui/material';

function TermsPage() {
  const sectionSpacing = { xs: '6rem', sm: '7rem', md: '7.8rem' };

  return (
    <>
      <NavBar isSimpleMode={true} />

      <section>
        <Box sx={{
          background: 'black',
          py: "4rem",
        }}>
          <Typography
            component='h1'
            sx={{
              color: 'white',
              fontSize: '3rem',
              textAlign: 'center',
              fontWeight: '800'
            }}>
            SplitEV INC. <br />  Terms Of Service
          </Typography>

          <Box sx={{
            m: 'auto',
            width: '80%',
            maxWidth: '70rem',
          }} >
            <Typography sx={{ fontSize: '1.8rem', textAlign: 'justify', my: '4rem', fontWeight: '300' }}>
              These terms service (the “Terms of Service”) are a legal agreement between you and SplitEVInc.
              (“SplitEV”, “we,” “us,” or “our”).  These Terms of Service specify the terms under which you may
              access and use our website located at https://www.SplitEV.co (the “Site”),  the SplitEV platform (the
              “Platform)  and   the   SplitEV   mobile   application     (the   “App”,”   and   together   with   the   Site,   the
              “Services”)
            </Typography>

            <Typography sx={{ fontSize: '1.8rem', textAlign: 'justify', my: '4rem', fontWeight: '300' }}>
              PLEASE   READ   THESE   TERMS   OF   SERVICE   CAREFULLY   BEFORE   ACCESSING   AND
              USING THE SERVICES OR ANY PORTION THEREOF, BECAUSE BY USING ANY OF THE
              SERVICES,   CLICKING   “I   AGREE,”   OR   OTHERWISE   MANIFESTING   YOUR   ASSENT   TO
              THESE TERMS OF SERVICE, YOU AGREE TO BE BOUND BY THESE TERMS OF SERVICE
              AND OUR PRIVACY POLICY (THE “PRIVACY POLICY”, TOGETHER WITH THE TERMS OF
              SERVICE, THE “AGREEMENT”), WHICH IS HEREBY INCORPORATED BY REFERENCE.  IF
              YOU DO NOT AGREE TO (OR CANNOT COMPLY WITH) ALL OF THE TERMS OF THESE
              TERMS OF SERVICE, DO NOT ACCESS OR USE THE SERVICES.
            </Typography>

            <Typography sx={{ fontSize: '1.8rem', textAlign: 'justify', my: '4rem', fontWeight: '800' }}>
              THE SECTIONS BELOW TITLED “BINDING ARBITRATION” AND “CLASS ACTION
              WAIVER” CONTAIN A BINDING ARBITRATION AGREEMENT, AND CLASS ACTION
              WAIVER.  THEY AFFECT YOUR LEGAL RIGHTS.  PLEASE READ THEM.
            </Typography>

            <Typography sx={{ fontSize: '1.8rem', textAlign: 'justify', my: '4rem', fontWeight: '400' }}>
              If you accept or agree to this Agreement on behalf of a company or other legal entity, you represent
              and warrant that you have the authority to bind that company or other legal entity to the Agreement
              and, in such event, “you” and “your” will refer and apply to that company or other legal entity
            </Typography>

            <Typography sx={{ fontSize: '1.8rem', textAlign: 'justify', my: '4rem', fontWeight: '300' }}>
              Capitalized terms not defined in these Terms of Service shall have the meaning set forth in our Privacy
              Policy
            </Typography>

            {/* TABLE OF CONTENTS */}
            <Typography sx={{ fontWeight: '600', mx: '1rem', pt: { xs: '6rem', sm: '6.8rem', md: '7.4rem' }, pb: '3rem', fontSize: '1.6rem' }} id="table-of-content">TABLE OF CONTENTS</Typography>

            <ol className="tc_table_of_content">
              <li>
                <a href="#services-and-users">Our services and users</a>
              </li>

              <li>
                <a href="#restrictions">Restrictions</a>
              </li>

              <li>
                <a href="#user-content-licenses">User contents & licences</a>
              </li>

              <li>
                <a href="#subscriber-terms">Subscriber terms</a>
              </li>

              <li>
                <a href="#host-term">Host terms</a>
              </li>

              <li>
                <a href="#intellectual-property">Intellectual property</a>
              </li>

              <li>
                <a href="#feedback">Feedback</a>
              </li>

              <li>
                <a href="#user-rights-and-restrictions">User rights & restrictions</a>
              </li>

              <li>
                <a href="#digital-copyright">Digital millennium copyright</a>
              </li>

              <li>
                <a href="#communication-decency">Communication decency act</a>
              </li>

              <li>
                <a href="#warranties-and-liabilities">No warranties and liability</a>
              </li>

              <li>
                <a href="#indemnification">Indemnification</a>
              </li>

              <li>
                <a href="#compliance-with-laws">Compliance with applicable laws</a>
              </li>

              <li>
                <a href="#controlling-law">Controlling law</a>
              </li>

              <li>
                <a href="#binding-arbitration">Binding arbitration</a>
              </li>

              <li>
                <a href="#class-action-waiver">Class action waivers</a>
              </li>

              <li>
                <a href="#equitable-relief">Equitable relief</a>
              </li>

              <li>
                <a href="#external-sites">External sites</a>
              </li>

              <li>
                <a href="#changes-to-agreement">Changes to agreement</a>
              </li>

              <li>
                <a href="#downloading-the-app">Downloading the app</a>
              </li>


              <li>
                <a href="#general">General</a>
              </li>

              <li>
                <a href="#how-to-contact-us">Contact us</a>
              </li>
            </ol>

            <ol className="">
              {/* OUR SERVICES AND USERS */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, fontSize: '1.6rem' }} id="services-and-users">
                  OUR SERVICES AND USERS
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1.5rem', textAlign: 'justify' }}>
                  The Services provide an electric vehicle (“EV”) charging (“EV Charger”) rental service for owners of
                  a residential or other EV Charger (“Hosts”) to offer their chargers for individuals who need to charge
                  their EVs (“Subscribers”).

                  <Typography sx={{ fontSize: '1.6rem', textAlign: 'justify', my: '1rem', fontWeight: '300' }}>
                    Our Services have several types of users:
                  </Typography>

                  <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'lower-alpha', m: '3rem', }} >
                    <li>
                      <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                        Visitors.
                      </Typography> Visitors to our Site, as the term implies, are people who do not register for an
                      account, but want to explore the Site for informational purposes.  No login is required for visitors to
                      the Site.  Visitors can access all publicly-available content and features of the Site, and can contact us
                      using the contact link on the Site.
                    </li>

                    <li>
                      <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                        Registered Users and Accounts.
                      </Typography> In order to become a Host and/or a Subscriber, you
                      must establish an account with us.  SplitEV is under no obligation to accept any individual or entity as
                      an account holder, and may accept or reject any registration in our sole and complete discretion.  Hosts
                      and Subscribers may sometimes be collectively referred to as “Users” in these Terms of Service.
                    </li>
                  </Box>

                  To create an account, you or your authorized representative will be prompted to create a password and
                  user name (“SplitEV User ID”) and perhaps provide certain additional information that will assist in
                  authenticating your identity when you log-in in the future (collectively “Login Credentials”).  You
                  may not transfer your account to anyone else without our prior written permission. When creating
                  your account, you must provide true, accurate, current, and complete information about yourself.
                  Each SplitEV User ID and corresponding password can be used by only one individual.   You are
                  responsible   for  maintaining  the   confidentiality  of  your  account   Login  Credentials.  You  are   fully
                  responsible for all activities that are associated with your account (including but not limited to any
                  Purchases (defined below), use of the Services, or communications from your account to SplitEV).
                  You agree to immediately notify us of any unauthorized use or suspected unauthorized use of your
                  account or any other breach of security.
                </Box>
              </li>

              {/* RESTRICTIONS */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', py: '2rem', pt: sectionSpacing, fontSize: '1.6rem' }} id="restrictions">
                  RESTRICTIONS
                </Box>

                <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'lower-alpha', m: '1.6rem', }} >
                  <li>
                    <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                      Age Restrictions.
                    </Typography>  The Services are available only to individuals aged 18 years or older.
                    If you are 18 or older, but under the age of majority in your jurisdiction, you should review this
                    Agreement with your parent or guardian to make sure that you and your parent or guardian understand
                    it.  We reserve the right, in our sole and absolute discretion, to deny you access to the Services, or any
                    portion   of   the   Services,   including   by   closing   or   disconnecting   your   account,   without   notice   and
                    without reason.
                  </li>
                </Box>
              </li>

              {/* USER CONTENT; LICENSES */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', py: '2rem', pt: sectionSpacing, fontSize: '1.6rem' }} id="user-content-licenses">
                  USER CONTENT; LICENSES
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  The Services may allow Users to post, send via chat, and upload content such as photos, images, text,
                  graphics,   and   other   materials   (collectively,   “User   Content”). Even if you are not a Host, as a
                  Subscriber you may have the opportunity to post or send via chat User Content such as comments,
                  product reviews, or other materials.
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  You expressly acknowledge and agree that once you submit your User Content for inclusion into the
                  Services, there is no confidentiality or privacy with respect to such User Content, including, without
                  limitation, any personally identifying information that you may make available. YOU, AND NOT
                  SPLITEV, ARE ENTIRELY RESPONSIBLE FOR ALL YOUR USER CONTENT THAT YOU
                  UPLOAD, POST, CHAT, E-MAIL, OR OTHERWISE TRANSMIT VIA THE SERVICES.  We are
                  not obligated to publish any User Content on our Services, and we reserve the right to remove any
                  User Content at any time in our sole discretion, with or without notice.
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  You retain all copyrights and other intellectual property rights in and to your own User Content.  You
                  do, however, hereby grant us and our sublicensees a non-exclusive, royalty-free, freely sublicensable,
                  perpetual,   irrevocable   license   to   modify,   compile,   combine   with   other   content,   copy,   record,
                  synchronize, transmit, translate, format, distribute, publicly display, publicly perform, and otherwise
                  use or exploit (including for profit) your User Content and all intellectual property and moral rights
                  therein throughout the universe, in each case, by or in any means, methods, media, or technology now
                  known or hereafter devised, subject to certain limitations related to SplitEV Marks, as set forth below.
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  If you submit User Content to us, each such submission constitutes a representation and warranty to
                  SplitEV that (i) you have received all necessary releases and consent from all individuals that appear
                  in the User Content, and (ii) such User Content is your original creation (or that you otherwise have
                  the right to provide the User Content), that you have the rights necessary to grant the license to the
                  User Content under the prior paragraph, and that the User Content and its use by SplitEV and our
                  content partners as permitted by this Agreement does not and will not infringe, misappropriate, or
                  otherwise violate the intellectual property rights, moral rights, or rights of privacy or publicity of any
                  person,   or   contain   any   libelous,   defamatory,   or   obscene   material   or   content   that   violates   the
                  Agreement.  You agree to defend, indemnify, and hold us, our affiliates, and our and their respective
                  owners, members, officers, directors, employees, agents, successors, licensees, licensors, and assigns
                  harmless from and against any damages, liabilities, losses, expenses, claims, actions, and/or demands,
                  including, without limitation, reasonable legal and accounting fees, arising or resulting from your
                  breach of the representations and warranties in this paragraph.
                </Box>

              </li>

              {/*  SUBSCRIBER TERMS.  */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', py: '2rem', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="subscriber-terms">
                  SUBSCRIBER TERMS.
                </Box>

                <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'lower-alpha', m: '1.6rem', textAlign: 'justify' }} >
                  <li>
                    <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                      Payments and Fees.
                    </Typography> To rent an EV Charger you must become a Subscriber. SplitEV
                    offers a monthly subscription service (“Subscription”) for a fee set forth on the Site (the “Subscription
                    Fee”).  SplitEV may add new fees and charges, or amend fees and charges, at any time in its sole
                    discretion.  SplitEV will seek to notify you by reasonable means of any material increase in such fee.
                    Subscribers shall pay all Subscription Fees in connection with their subscription.  By purchasing a
                    subscription (“Purchase”), Subscriber is agreeing to pay SplitEV, through our third-party payment
                    processor, Stripe, Inc. (“Payment Processor” or “Stripe”), all fees at the prices then in effect for such
                    Purchase in accordance with the applicable fee terms provided by us.  If Subscriber has a card or other
                    payment method on file with its account on the Platform, by purchasing a Subscription,  Subscriber
                    may be authorizing us, through Payment Processor, to charge such account for the Purchase amount.
                    By using the Services to purchase a Subscription, you agree to Stripe’s Terms of Use and Privacy
                    Policy, located here:   https://stripe.com/us/terms     and  https://stripe.com/us/privacy   .    SUBSCRIBERS
                    MUST  PROVIDE  CURRENT, COMPLETE, AND ACCURATE  INFORMATION FOR  THEIR
                    ACCOUNTS, AND PROMPTLY UPDATE ALL INFORMATION TO KEEP SUCH ACCOUNT
                    INFORMATION   CURRENT,   COMPLETE,   AND   ACCURATE   (SUCH   AS   A   CHANGE   IN
                    BILLING ADDRESS, CREDIT CARD NUMBER, OR CREDIT CARD EXPIRATION DATE).
                    FURTHER,  SUBSCRIBERS  MUST   PROMPTLY  NOTIFY  US  IF  A  PAYMENT  METHOD  IS
                    CANCELED (E.G., FOR LOSS OR THEFT) OR IF SUBSCRIBER BECOMES AWARE OF A
                    POTENTIAL BREACH OF SECURITY, SUCH AS THE UNAUTHORIZED DISCLOSURE OR
                    USE   OF   SUBSCRIBER’S   USER   NAME   OR   PASSWORD.  CHANGES   TO   SUCH
                    INFORMATION CAN BE MADE AT SUBSCRIBER’S ACCOUNT PAGE.

                    <Typography sx={{ fontSize: '1.4rem', textAlign: 'justify', my: '4rem', fontWeight: '600', textTransform: 'italic' }}>
                      By purchasing a Subscription, Subscriber acknowledges that Subscriber’s Subscription has
                      an initial and recurring payment charge at the then-current Subscription rate, Subscriber agrees
                      that SplitEV may submit monthly charges, in advance to Subscriber’s chosen payment method
                      without further authorization from Subscriber, until Subscriber provide notice to SplitEV that
                      Subscriber wishes to cancel Subscriber’s Subscription or to change Subscriber’s payment method.
                      Subscriber further accepts responsibility for all recurring charges prior to cancellation, including,
                      where applicable, any charges processed by SplitEV after the expiration date of your payment
                      card
                    </Typography>

                    <Typography sx={{ fontSize: '1.4rem', textAlign: 'justify', my: '4rem', fontWeight: '600', textTransform: 'italic' }}>
                      Subscriber   may  change   or   terminate   Subscriber’s   Subscription   by  emailing   us   at
                      contact@getSplitEV.com. If Subscriber terminates Subscriber’s Subscription, Subscriber may use
                      Subscriber’s Subscription until the end of the then-current billing cycle, and the Subscription
                      will not be renewed after that period expires. SplitEV does not refund any pre-paid portion of the Subscription
                      fee. SplitEV may immediately terminate or suspend Subscriber’s Subscription for any reason or no
                      reason in accordance with these Terms of Service. If we terminate or suspend   Subscriber’s
                      Subscription, Subscriber’s license to use any software or content provided in connection with the
                      Subscription is also terminated or suspended (as applicable).
                    </Typography>
                  </li>

                  <li>
                    <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                      Subscriber Representations and Warranties
                    </Typography> As a Subscriber you represent and warrant
                    that:

                    <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'lower-alpha', m: '3rem', }} >
                      <li>
                        You are the legal owner of or have received adequate permission from the legal
                        owner to use the EV that will be receiving in the Services;
                      </li>

                      <li>
                        The Subscriber carries adequate vehicle insurance and registration as dictated
                        by all applicable laws for the EV;
                      </li>

                      <li>
                        You will not commit any illegal acts against the Host’s person or property
                        when using the Services;
                      </li>

                      <li>
                        You will follow and abide by all applicable laws that could be implicated with
                        your use of the Services; and
                      </li>

                      <li>
                        You will  act  in a  proper manner at  all  times while  using the  Services and
                        respect the Host and all Users of the Services
                      </li>
                    </Box>
                  </li>
                </Box>
              </li>

              {/*   HOST TERMS */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', py: '2rem', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="host-term">
                  HOST TERMS
                </Box>

                <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'lower-alpha', m: '1.6rem', textAlign: 'justify' }} >
                  <li>
                    <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                      Rentals.
                    </Typography>  A Subscriber can rent an EV Charger on the Platform, Site or Application
                    with a Host. SplitEV shall receive the rent  information from the Subscriber and send it to the Host.
                    Host and Subscriber shall then confirm the rental on the Platform.   Other than the limited information
                    necessary to enable the rental, all Subscriber information shall be held exclusively by SplitEV, in
                    accordance   with   our   Privacy   Policy,   and   Host   shall   not   have   the   ability   to   communicate   with
                    Subscribers without using SplitEV Platform, Site or Application.
                  </li>

                  <li>
                    <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                      Payments.
                    </Typography> Host will receive payment for every rental of their EV Charger registered
                    on the Platform, Site or Application less a fifteen percent (15%) access fee due to SplitEV. Such
                    payment terms shall be set forth on the Platform, Site or Application. SplitEV reserves the right to
                    amend payment terms at any time in its sole discretion.
                  </li>

                  <li>
                    <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                      Host Representations and Warranties.
                    </Typography> As a Host, you represent and warrant that


                    <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'lower-alpha', m: '4rem', }} >
                      <li>
                        You are the legal owner of or    have received adequate permission from the
                        legal owner to rent the EV Charger that will be used in the Services
                      </li>

                      <li>
                        You   are   the   legal   owner   of   or   have   received   adequate   permission   to   the
                        residential area or EV Charger location that will be used in the Services;
                      </li>

                      <li>
                        You are in compliance with all applicable laws concerning your EV Charger;
                      </li>

                      <li>
                        You have followed all rules, regulations and instructions on the installation,
                        maintenance and repair of your EV Charger;
                      </li>

                      <li>
                        If your EV Charger is in a residential location, you are in compliance with and
                        have adequate homeowners or rental insurance required in your jurisdiction
                      </li>

                      <li>
                        You will keep  the area around your EV Charger clean and safe for use
                      </li>

                      <li>
                        You will not commit any illegal acts against the Subscriber’s person or
                        property when using the Services
                      </li>

                      <li>
                        You will follow and abide by all applicable laws that could be implicated with
                        your use of the Services; and
                      </li>

                      <li>
                        You will  act  in a  proper manner at  all  times while  using the  Services and
                        respect the Subscriber and all Users of the Services.
                      </li>

                    </Box>
                  </li>

                  <li>
                    <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                      Performance Metrics.
                    </Typography> SplitEV cares deeply about customer satisfaction. Accordingly,
                    we reserve the right to track and measure Hosts’ use of the Services and performance in accordance
                    with   this   Agreement.     We   reserve   the   right   to   track   Rentals,   Subscriber   complaints,
                    cancellation/request for chargebacks, and related logistics and performance issues.   These metrics
                    help us determine whether a Host is meeting our and our Subscribers’ expectations. If we determine,
                    in our sole discretion, that Host is not meeting our performance standards, is in violation of this
                    Agreement, or for other reasons, we reserve the right to suspend or remove your account with the
                    Services.
                  </li>
                </Box>
              </li>

              {/* INTELLECTUAL PROPERTY */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="intellectual-property">
                  INTELLECTUAL PROPERTY
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  The Services contains material, such as software, text, graphics, images, and other material provided
                  by or on behalf of SplitEV (collectively referred to as the “Content”).  The Services and the Content
                  are protected under United States and foreign laws.   The Services and Content are protected by
                  copyright, trademark, and other laws of the United States and foreign countries.  Except as expressly
                  provided in this Agreement, SplitEV and our licensors exclusively own all right, title, and interest in
                  and to the Services and Content, including all associated intellectual property rights.
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  You may not (i) remove, alter, or obscure any copyright, trademark, service mark, or other proprietary
                  rights notices incorporated in or accompanying the Services or the Content, or (ii) sell, transfer,
                  assign, license, sublicense, or modify the Services or the Content or reproduce, display, publicly
                  perform, make a derivative version of, distribute, or otherwise use the Services or Content in any way
                  for any public or commercial purpose.
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  The trademarks, service marks, and logos of SplitEV (the “SplitEV Trademarks”) used and displayed
                  on   the   Services   are   registered   and   unregistered   trademarks   or   service   marks   of SplitEV. Other
                  company and service names located on the Services may be trademarks or service marks owned by
                  third   parties   (the   “Third-Party   Trademarks,”   and,   collectively   with   SplitEV   Trademarks,   the
                  “Trademarks”).  Nothing on the Services should be construed as granting, by implication, estoppel, or
                  otherwise, any license or right to use the Trademarks, without our prior written permission specific for
                  each such use.   Use of the Trademarks as part of a link to or from any site is prohibited unless
                  establishment of such a link is approved in advance by us in writing.  All goodwill generated from the
                  use of SplitEV Trademarks inures to our benefit.
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  Elements of the Services are protected by trade dress, trademark, unfair competition, and other state
                  and federal laws and may not be copied or imitated in whole or in part, by any means, including, but
                  not limited to, the use of framing or mirrors.  None of the Content may be retransmitted without our
                  express, written consent for each and every instance
                </Box>
              </li>

              {/* FEEDBACK */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="feedback">
                  FEEDBACK
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  As a registered User of our Services, you may elect to provide us with feedback,
                  comments, and suggestions with respect to our Services (“Feedback”).  You agree that SplitEV will be
                  free   to   use,   reproduce,   disclose,   and   otherwise   exploit   any   and   all   such   Feedback   without
                  compensation or attribution to you.
                </Box>
              </li>

              {/*  USAGE RIGHTS AND RESTRICTIONS */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="user-rights-and-restrictions">
                  USAGE RIGHTS AND RESTRICTIONS
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  Subject to   the   terms   and   conditions   of   this
                  Agreement, SplitEV grants you a limited, non-transferable, non-exclusive, license to access and use
                  the Services solely for your personal purposes. SplitEV may terminate this license at any time for any
                  reason.  Further, when using or accessing the Services, you agree tha
                </Box>

                <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'disc', m: '3rem', textAlign: 'justify' }} >
                  <li>
                    You   will   not   upload,   post,   chat,   e-mail,   transmit,   or   otherwise   make   available   any   User
                    Content that:

                    <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'circle', m: '3rem', }} >
                      <li>
                        Infringes any copyright, trademark, right of publicity, or other proprietary rights of any
                        person or entity; or
                      </li>

                      <li>
                        is defamatory, libelous, indecent, obscene, pornographic, sexually explicit, invasive of
                        another’s privacy, promotes violence or illegal activity, or contains hate speech (i.e.,
                        speech   that   attacks   or   demeans   a   group   based   on   race   or   ethnic   origin,   religion,
                        disability, gender, age, veteran status, and/or sexual orientation/gender identity); o
                      </li>

                      <li>
                        discloses any sensitive information about another person, including that person’s e-
                        mail address, postal address, phone number, credit card information, or any similar
                        information
                      </li>
                    </Box>
                  </li>

                  <li>
                    You will comply with all applicable laws in your use of the Services and will not use the
                    Services for any unlawful purpose
                  </li>

                  <li>
                    You   will   not   access   or   use   the   Services   to   collect   any   market   research   for   a   competing
                    business;
                  </li>

                  <li>
                    You will not impersonate any person or entity or falsely state or otherwise misrepresent your
                    affiliation with a person or entity
                  </li>

                  <li>
                    You   will   not   interfere   with,   or   attempt   to   interrupt   the   proper   operation   of,   the   Services
                    through   the   use   of   any   virus,   device,   information   collection   or   transmission   mechanism,
                    software or routine, or access or attempt to gain access to any Content, data, files, or passwords
                    related to the Services through hacking, password or data mining, or any other means;
                  </li>


                  <li>
                    You will not decompile, reverse engineer, or disassemble any software or other products or
                    processes accessible through the Services
                  </li>


                  <li>
                    You will not cover, obscure, block, or in any way interfere with any advertisements and/or
                    safety features on the Services;
                  </li>

                  <li>
                    You will not use any robot, spider, scraper, or other automated means to access the Services
                    for any purpose without our express written permission;
                  </li>

                  <li>
                    You   will   not   take   any   action   that   imposes   or   may   impose   (in   our   sole   discretion)   an
                    unreasonable or disproportionately large load on our technical infrastructure;
                  </li>

                  <li>
                    You will not allow anyone to access and use your account;
                  </li>

                  <li>
                    You will not resell, distribute, or sublicense the Services or use it for the benefit of anyone
                    other than you or your business;
                  </li>

                  <li>
                    You will not remove or modify any proprietary markings or restrictive legends placed on the
                    Services; and
                  </li>
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  You will not introduce, post, or upload to the Services any Harmful Code. As used herein, “Harmful
                  Code” means computer code, programs, or programming devices that are intentionally designed to
                  disrupt,   modify,   access,   delete,   damage,   deactivate,   disable,   harm,   or   otherwise   impede   in   any
                  manner, including aesthetic disruptions or distortions, the operation of the Services, or any other
                  associated software, firmware, hardware, computer system, or network (including, without limitation,
                  “Trojan horses,” “viruses,” “worms,” “time bombs,” “time locks,” “devices,” “traps,” “access codes,”
                  or “drop dead” or “trap door” devices) or any other harmful, malicious, or hidden procedures, routines
                  or mechanisms that would cause the Services to cease functioning or to damage or corrupt data,
                  storage media, programs, equipment, or communications, or otherwise interfere with the operations of
                  the Services.SplitEV reserves the right, at any time, to modify, suspend, or discontinue the Services or
                  any part thereof with or without notice. You agree that we will not be liable to you or to any third party
                  for any modification, suspension, or discontinuance of the Services or any part thereof. You are free to
                  stop using the Services at any time.
                </Box>
              </li>

              {/*  DIGITAL MILLENNIUM COPYRIGHT ACT */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="digital-copyright">
                  DIGITAL MILLENNIUM COPYRIGHT ACT
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  SplitEV respects the intellectual property rights of others and attempts to comply with all relevant
                  laws. We will review all claims of copyright infringement received and remove any Content or User
                  Content deemed to have been posted or distributed in violation of any such laws.
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  Our designated agent under the Digital Millennium Copyright Act (the “Act”) for the receipt of any
                  Notification of Claimed Infringement which may be given under that Act is as follows:

                  <Typography variant='blockquote' sx={{ maxWidth: '20rem', m: '1.2rem 15%', display: 'block' }}>
                    Email: <br />
                    charge@splitev.co
                  </Typography>

                  <Typography variant='blockquote' sx={{ maxWidth: '20rem', m: '1.2rem 15%', display: 'block' }}>
                    Address: <br />
                    SplitEV, Inc. <br />
                    377 Valley Rd Clifton NJ, #1310
                    Clifton, New Jersey 07013
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  If you believe that your work has been copied on the Services in a way that constitutes copyright
                  infringement, please provide our agent with notice in accordance with the requirements of the Act,
                  including (i) a description of the copyrighted work that has been infringed and the specific location on
                  the   Services   where   such   work   is   located;   (ii)   a   description   of   the   location   of   the   original   or   an
                  authorized copy of the copyrighted work; (iii) your address, telephone number and e-mail address; (iv)
                  a statement by you that you have a good faith belief that the disputed use is not authorized by the
                  copyright owner, its agent or the law; (v) a statement by you, made under penalty of perjury, that the
                  information in your notice is accurate and that you are the copyright owner or authorized to act on the
                  copyright owner’s behalf; and (vi) an electronic or physical signature of the owner of the copyright or
                  the person authorized to act on behalf of the owner of the copyright interest.
                </Box>
              </li>

              {/*  COMMUNICATIONS DECENCY ACT NOTICES */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="communication-decency">
                  COMMUNICATIONS DECENCY ACT NOTICE
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  SplitEV   is   a   provider   of   “interactive   computer   services”   as   defined   under   the   Communications
                  Decency   Act,   47   U.S.C.   Section   230,   and   as   such,   our   liability   for   defamation,   libel,   product
                  disparagement, and other claims arising out of any User Content is limited as described therein.  We
                  are not responsible for any User Content.  We neither warrant the accuracy of the User Content nor
                  exercise any editorial control over User Content, nor do we assume any legal obligation for editorial
                  control of User Content or liability in connection with User Content, including any responsibility or
                  liability for investigating or verifying the accuracy of any User Content.
                </Box>
              </li>

              {/*  NO WARRANTIES; LIMITATION OF LIABILITY */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="warranties-and-liabilities">
                  NO WARRANTIES; LIMITATION OF LIABILITY
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  THE SERVICES, AND ALL CONTENT AND OTHER INFORMATION ON OR ACCESSIBLE
                  FROM OR THROUGH THE SERVICES ARE PROVIDED BY SPLITEV ON AN “AS IS” AND
                  “AS AVAILABLE” BASIS WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR
                  IMPLIED.  SPLITEV EXPRESSLY DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED,
                  REGARDING THE SERVICES, THE CONTENT, AND ALL EV CHARGERS OFFERED BY
                  HOSTS THROUGH THE SERVICES, INCLUDING BUT NOT LIMITED TO WARRANTIES OF
                  MERCHANTABILITY,   FITNESS   FOR   A   PARTICULAR   PURPOSE,   NON-INFRINGEMENT,
                  SECURITY   OR   ACCURACY,   AND   ANY   WARRANTIES   ARISING   FROM   COURSE   OF
                  DEALING, COURSE OF PERFORMANCE, OR USAGE OF TRADE. WITHOUT LIMITING THE
                  GENERALITY   OF   THE   FOREGOING,   SPLITEV   DOES   NOT   WARRANT   THAT:   (1)   THE
                  INFORMATION   ON   THE   SERVICES   IS   CORRECT,   ACCURATE   OR   RELIABLE;   (2)   THE
                  FUNCTIONS CONTAINED ON THIS SERVICES WILL BE UNINTERRUPTED OR ERROR-
                  FREE; OR (3) DEFECTS WILL BE CORRECTED, OR THAT THE SERVICES OR THE SERVER
                  THAT   MAKE   THEM   AVAILABLE   IS   FREE   OF   VIRUSES   OR   OTHER   HARMFUL
                  COMPONENTS
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  YOU UNDERSTAND THAT SPLITEV DOES NOT MANUFACTURE, MARKET, OR INSPECT
                  ANY OF THE EV CHARGERS RENTED  THROUGH OUR SERVICES. WE FACILITATE THE
                  LISTING   OF     THE   EV   CHARGERS       OFFERED   DIRECTLY   BY   HOSTS,   AND,
                  ACCORDINGLY, SPLITEV CANNOT AND DOES NOT MAKE ANY WARRANTIES ABOUT
                  THEIR QUALITY, SAFETY, OR EVEN THEIR LEGALITY. AS A SUBSCRIBER, ANY LEGAL
                  CLAIM RELATED TO AN EV CHARGER YOU RENT THROUGH THE SERVICES MUST BE
                  BROUGHT DIRECTLY AGAINST THE HOST OF THE PRODUCT. YOU HEREBY RELEASE
                  SPLITEV   FROM   ANY   CLAIMS   RELATED   TO   EV   CHARGERS   AND   THEIR   LOCATIONS
                  PROVIDED   THROUGH   OUR   SERVICES,   INCLUDING   FOR   DEFECTIVE   EV   CHARGERS,
                  MISREPRESENTATIONS   BY   HOSTS,   OR   ITEMS   THAT   CAUSED   PHYSICAL   INJURY
                  (PRODUCT LIABILITY CLAIMS).
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  IN   CONNECTION   WITH   ANY   WARRANTY,   CONTRACT,   OR   COMMON   LAW   TORT
                  CLAIMS: (I) WE SHALL NOT BE LIABLE FOR ANY INCIDENTAL OR CONSEQUENTIAL
                  DAMAGES, LOST PROFITS, OR DAMAGES RESULTING FROM LOST DATA OR BUSINESS
                  INTERRUPTION RESULTING FROM THE USE OR INABILITY TO ACCESS AND USE THE
                  SERVICES, THE PRODUCTS, OR THE CONTENT, EVEN IF WE HAVE BEEN ADVISED OF
                  THE   POSSIBILITY   OF   SUCH   DAMAGES;   AND   (II)   ANY   DIRECT   DAMAGES,   NOT
                  ATTRIBUTABLE TO PERSONAL INJURIES, THAT YOU MAY SUFFER AS A RESULT OF
                  YOUR USE OF THE SERVICES OR THE CONTENT SHALL BE LIMITED TO ONE HUNDRED
                  UNITED STATES DOLLARS (US $100).   SPLITEV SHALL NOT BE LIABLE FOR DIRECT
                  DAMAGES THAT YOU MAY SUFFER AS A RESULT OF YOUR USE OF ANY EV CHARGER.
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  SOME JURISDICTIONS, INCLUDING THE STATE OF NEW JERSEY, DO NOT ALLOW THE
                  EXCLUSION   OF   CERTAIN   WARRANTIES   OR   LIMITATION   OF   CERTAIN   LIABILITIES.
                  THEREFORE, SOME OF THE ABOVE LIMITATIONS IN THIS SECTION MAY NOT APPLY
                  TO YOU.
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  NOTHING   IN   THIS   AGREEMENT   SHALL   AFFECT   ANY   NON-WAIVABLE   STATUTORY
                  RIGHTS THAT APPLY TO YOU.
                </Box>
              </li>

              {/*  INDEMNIFICATION */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="indemnification">
                  INDEMNIFICATION
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  Hosts shall indemnify, defend, and hold harmless SplitEV, its affiliates, and its and their respective
                  officers,   managers,   partners,   employees,   and   agents   from   and   against   any   and   all   losses,   civil
                  penalties, liabilities, damages, judgments, costs, and expenses, including reasonable attorney’s fees
                  and court costs, incurred in connection with any proceeding, claim, or action  arising out of or related
                  to (i) any alleged defect in or injury from Host’s EV Charger or any other products liability claim;  (ii)
                  the   alleged   failure   of   Host   or   Host’s   EV   Charger   to   comply   with   this   Agreement   or   any   laws,
                  regulations, warranties, guarantees, or representations of Host; (iii) any and all breaches of the Host’s
                  representations   and   warranties;   and   (iv)   negligence,   willful   misconduct   and   fraud   committed   by
                  Subscriber.
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '2rem', textAlign: 'justify' }}>
                  Subscribers   shall   indemnify,   defend,   and   hold   harmless   SplitEV,   its   affiliates,   and   its   and   their
                  respective officers, managers, partners, employees, and agents from and against any and all losses,
                  civil penalties, liabilities, damages, judgments, costs, and expenses, including reasonable attorney’s
                  fees and court costs, incurred in connection with any proceeding, claim, or action, arising out of or
                  related to (i) any alleged damage to Host’s EV Charger or any other products liability claim; and  (ii)
                  the alleged failure of Subscriber or Subscriber’s EV to comply with this Agreement or any laws,
                  regulations, warranties, guarantees, or representations of Host; (iii) any and all breaches of the Host’s
                  representations   and   warranties;   and   (iv)   negligence,   willful   misconduct   and   fraud   committed   by
                  Subscriber.
                </Box>
              </li>

              {/*  COMPLIANCE WITH APPLICABLE LAWS */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="compliance-with-laws">
                  COMPLIANCE WITH APPLICABLE LAWS
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  The Services are based in the United States.  We make no claims concerning whether the Services are
                  accessible, or whether Content may be downloaded, viewed, or be appropriate for use, or Purchases
                  may be made, outside of the United States.  Whether inside or outside of the United States, you are
                  solely responsible for ensuring compliance with the laws of your specific jurisdiction.
                </Box>
              </li>

              {/*  CONTROLLING LAW */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="controlling-law">
                  CONTROLLING LAW
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  This Agreement and any action related thereto will be governed by the laws of the State of New York
                  without regard to its conflict of laws provisions.
                </Box>
              </li>

              {/* BINDING ARBITRATION */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="binding-arbitration">
                  BINDING ARBITRATION
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  In the event of a dispute arising between you and SplitEV under or relating to this Agreement or the
                  Services (not a dispute between a Subscriber and a Host) (each, a “Dispute”), such Dispute will be
                  finally   and   exclusively   resolved   by   binding   arbitration   governed   by   the   Federal   Arbitration   Act
                  (“FAA”).   Any election to arbitrate, at any time, shall be final and binding on the other party. IF
                  EITHER YOU OR SPLITEV CHOOSES ARBITRATION, NEITHER PARTY SHALL HAVE THE
                  RIGHT TO LITIGATE SUCH CLAIM IN COURT OR  TO HAVE  A JURY TRIAL, EXCEPT
                  EITHER   PARTY   MAY   BRING   ITS   CLAIM   IN   ITS   LOCAL   SMALL   CLAIMS   COURT,   IF
                  PERMITTED BY THAT SMALL CLAIMS COURT RULES AND IF WITHIN SUCH COURT’S
                  JURISDICTION.   ARBITRATION IS DIFFERENT FROM COURT, AND DISCOVERY AND
                  APPEAL RIGHTS MAY ALSO BE LIMITED IN ARBITRATION.  All disputes will be resolved
                  before a neutral arbitrator selected jointly by you and SplitEV, whose decision will be final, except for
                  a limited right of appeal under the FAA.  The arbitration shall be commenced and conducted by JAMS
                  pursuant to its then current Comprehensive Arbitration Rules and Procedures and in accordance with
                  the   Expedited   Procedures   in   those   rules,   or,   where   appropriate,   pursuant   to   JAMS’   Streamlined
                  Arbitration Rules and Procedures. All applicable JAMS’ rules and procedures are available at the
                  JAMS website www.jamsadr.com. Each of you and SplitEV will be responsible for paying any JAMS
                  filing, administrative, and arbitrator fees in accordance with JAMS rules.  Judgment on the arbitrator’s
                  award may be entered in any court having jurisdiction. This clause shall not preclude parties from
                  seeking   provisional   remedies   in   aid   of   arbitration   from   a   court   of   appropriate   jurisdiction.     The
                  arbitration may be conducted in person, through the submission of documents, by phone, or online. If
                  conducted in person, the arbitration shall take place in the United States county where you reside.  The
                  parties may litigate in court to compel arbitration, to stay a proceeding pending arbitration, or to
                  confirm, modify, vacate, or enter judgment on the award entered by the arbitrator.  The parties shall
                  cooperate in good faith in the voluntary and informal exchange of all non-privileged documents and
                  other information (including electronically stored information) relevant to the Dispute immediately
                  after commencement of the arbitration.  As set forth in Section 20 below, nothing in this Agreement
                  will prevent us from seeking injunctive relief in any court of competent jurisdiction as necessary to
                  protect our proprietary interests.
                </Box>
              </li>

              {/* CLASS ACTION WAIVER */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="class-action-waiver">
                  CLASS ACTION WAIVER
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  You agree that any arbitration or proceeding shall be limited to the Dispute between us and you
                  individually. To the full extent permitted by law, (i) no arbitration or proceeding shall be joined with
                  any other; (ii) there is no right or authority for any Dispute to be arbitrated or resolved on a class
                  action-basis or to utilize class action procedures; and (iii) there is no right or authority for any Dispute
                  to be brought in a purported representative capacity on behalf of the general public or any other
                  persons.   YOU   AGREE   THAT   YOU   MAY   BRING   CLAIMS   AGAINST   US   ONLY   IN   YOUR
                  INDIVIDUAL   CAPACITY   AND   NOT   AS   A   PLAINTIFF   OR   CLASS   MEMBER   IN   ANY
                  PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.
                  protect our proprietary interests.
                </Box>
              </li>

              {/* EQUITABLE RELIEF */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="equitable-relief">
                  EQUITABLE RELIEF
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  You acknowledge and agree that in the event of a breach or threatened violation of our intellectual
                  property rights and confidential and proprietary information by you, we will suffer irreparable harm
                  and will therefore be entitled to injunctive relief to enforce this Agreement. We may, without waiving
                  any   other   remedies   under   this   Agreement,   seek   from   any   court   having   jurisdiction   any   interim,
                  equitable, provisional, or injunctive relief that is necessary to protect our rights and property pending
                  the outcome of the arbitration referenced above. You hereby irrevocably and unconditionally consent
                  to   the   personal   and   subject   matter   jurisdiction   of   the   federal   and   state   courts   in   Los   Angeles,
                  California for purposes of any such action by us.
                </Box>
              </li>

              {/* EXTERNAL SITES */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="external-sites">
                  EXTERNAL SITES
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  The Services may contain links to third-party websites (“External Sites”).  These links are provided
                  solely as a convenience to you and not as an endorsement by us of the content on such External Sites.
                  The content of such External Sites is developed and provided by others.  You should contact the site
                  administrator or webmaster for those External Sites if you have any concerns regarding such links or
                  any content located on such External Sites.   We are not responsible for the content of any linked
                  External Sites and do not make any representations regarding the content or accuracy of materials on
                  such External Sites.  You should take precautions when downloading files from all websites to protect
                  your computer from viruses and other destructive programs.  If you decide to access linked External
                  Sites, you do so at your own risk
                </Box>
              </li>

              {/* CHANGES TO THE AGREEMENT */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="changes-to-agreement">
                  CHANGES TO THE AGREEMENT
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  These Terms of Service are effective as of the last updated date stated at the top.  We may change these
                  Terms of Service from time to time.  Any such changes will be posted on the Site.  By accessing the
                  Services after we make any such changes to these Terms of Service, you are deemed to have accepted
                  such changes.  Please refer back to these Terms of Service on a regular basis
                </Box>
              </li>

              {/* DOWNLOADING THE APPLICATION. */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2rem', fontSize: '1.6rem' }} id="downloading-the-app">
                  DOWNLOADING THE APPLICATION
                </Box>

                <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'lower-alpha', m: '1.6rem', }} >
                  <li>
                    <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                      Apple App Store
                    </Typography>

                    <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'disc', m: '1.6rem', }} >
                      <li>
                        We make the Services available through the Apple App Store.   The following terms apply
                        when you download the App from Apple’s App Store.  These terms are in addition to all other
                        terms contained in the Agreement
                      </li>

                      <li>
                        You acknowledge and agree that (i) the Agreement is concluded between you and SplitEV
                        only, and not Apple; and (ii) SplitEV, not Apple, is solely responsible for the Marketplace and
                        content thereof.  Your use of the App must comply with the App Store Terms of Service
                      </li>

                      <li>
                        You acknowledge that Apple has no obligation whatsoever to furnish any maintenance and
                        support services with respect to the App.
                      </li>

                      <li>
                        In the event of any failure of any of the App to conform to any applicable warranty, you may
                        notify Apple, and Apple will refund the purchase price, if any, for the App to you and, to the
                        maximum extent permitted by applicable law, Apple will have no other warranty obligation
                        whatsoever with respect to the App.  As between SplitEV and Apple, any other claims, losses,
                        liabilities, damages, costs, or expenses attributable to any failure to conform to any warranty
                        will be the sole responsibility of SplitEV.
                      </li>

                      <li>
                        You acknowledge that, in the event of any third-party claim that the App or your possession
                        and use of the App infringes that third party’s intellectual property rights, as between SplitEV
                        and   Apple,   SplitEV,   not   Apple,   will   be   solely   responsible   for   the   investigation,   defense,
                        settlement, and discharge of any such intellectual property infringement claim to the extent
                        required by the Agreement.
                      </li>

                      <li>
                        You acknowledge and agree that Apple, and Apple’s subsidiaries, are third-party beneficiaries
                        of the Agreement as related to your license of the App, and that, upon your acceptance of the
                        terms and conditions of the Agreement, Apple will have the right (and will be deemed to have
                        accepted the right) to enforce the Agreement as related to your license of the App against you
                        as a third-party beneficiary thereof.
                      </li>
                    </Box>
                  </li>

                  <li>
                    <Typography variant='span' sx={{ mb: '1rem', fontSize: '1.7rem', fontWeight: '700', textDecoration: 'underline' }}>
                      Google Play Store
                    </Typography>

                    <Box component='ol' sx={{ display: 'flex', gap: '3rem', flexDirection: 'column', listStyleType: 'disc', m: '1.6rem', }} >
                      <li>
                        We make the Services available through the Google Play Store. The following applies to the
                        App when you download it from the Google Play Store (the App when downloaded from the
                        Google Play Store shall be referred to herein as “Google-Sourced Software”) These terms are
                        in addition to all other terms contained in the Agreement.
                      </li>

                      <li>
                        You acknowledge that these Terms of Service  are between you and SplitEV only, and not
                        with Google, Inc. (“Google”).
                      </li>

                      <li>
                        Your use of Google-Sourced Software must comply with Google’s then-current Google Play
                        Terms of Use
                      </li>

                      <li>
                        Google is only a provider of Google Play where you obtained the Google-Sourced Software;
                      </li>

                      <li>
                        SplitEV, and not Google, is solely responsible for the Google-Sourced Software;
                      </li>

                      <li>
                        Google has no obligation or liability to you with respect to the Google-Sourced Software or
                        these Terms of Use;
                      </li>

                      <li>
                        You acknowledge and agree that Google is a third-party beneficiary to this Agreement as it
                        relates to the Google-Sourced Software.
                      </li>
                    </Box>
                  </li>
                </Box>
              </li>

              {/* GENERAL */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="general">
                  GENERAL
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  No failure or delay by SplitEV in exercising any right or remedy under the Agreement will operate, or
                  be deemed to operate, as a waiver of any such right or remedy.  If any provision of the Agreement is
                  found invalid or unenforceable by a court of competent jurisdiction, that provision will be amended
                  and the remainder of the Agreement will remain in full force and effect.  The Agreement constitutes
                  the final and complete agreement between you and SplitEV regarding the subject matter hereof, and
                  supersede any prior or contemporaneous communications, representations, or agreements between us,
                  whether oral or written, including, without limitation, any confidentiality or non-disclosure
                  agreements. Headings are for convenience only and shall not be used to limit or interpret the meaning
                  of any of the provisions of the Agreement.   Terms which by their nature are intended to survive
                  indefinitely shall survive and shall apply to you even if you have canceled your account or stopped
                  using the Services, including, without limitation, the limitations of liability, indemnity, and dispute
                  resolution provisions.
                </Box>
              </li>


              {/*  HOW TO CONTACT US */}
              <li>
                <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="how-to-contact-us">
                  HOW TO CONTACT US
                </Box>

                <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
                  If you have any questions or comments about this Privacy Policy, our privacy practices, or if you
                  would like to exercise your rights and choices, please email us at: <Box
                    component='a'
                    href="mailto:press@splitev.app"
                    sx={{
                      color: "#fff",
                      fontSize: "1.4rem",
                      fontWeight: 400,
                      textAlign: "left",
                      textDecorationLine: "underline",
                      width: 'fit-content',
                      display: 'contents'
                    }}
                  >
                    press@splitev.app
                  </Box>
                </Box>
              </li>
            </ol>

            <Box component='h6' sx={{ fontWeight: '500', pt: sectionSpacing, mb: '2.5rem', fontSize: '1.6rem' }} id="how-to-contact-us">
              ©{new Date().getFullYear()} SplitEV. All rights reserved.
            </Box>

            <Box sx={{ display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem', textAlign: 'justify' }}>
              YOU HEREBY ACKNOWLEDGE THAT YOU HAVE READ THESE TERMS, UNDERSTAND
              THEM, AND AGREE TO BE BOUND BY THEM.  IF YOU ARE ENTERING THESE TERMS ON
              BEHALF   OF   AN   ENTITY,   YOU   REPRESENT   AND   WARRANT   THAT   YOU   HAVE   THE
              RIGHT AND AUTHORITY TO LEGALLY BIND THE ENTITY TO THESE TERMS.
            </Box>
          </Box>

          <div>
            <Box component='a'
              href="#table-of-content"
              sx={{
                width: 'fit-content',
                textDecoration: 'none',
                position: 'fixed',
                right: '2rem',
                bottom: '2rem',
                border: '1rem',
                background: 'white',
                borderRadius: '5rem',
                p: '1.4rem', px: '2rem',
              }}
            >
              Table of Contents
            </Box>
          </div>
        </Box>
      </section >

      <Footer />
    </>
  );
}

export default TermsPage;

